import React from "react";
import ContactFormSeenaApps from "../../components/contact-us-seena-apps";

const ContactAll = () => {
  return <ContactFormSeenaApps />;
};

export default ContactAll;
